import type {PosterOp, SnapshotRecord} from '@PosterWhiteboard/collaboration/poster-op.types';
import {applyPosterOps} from '@PosterWhiteboard/collaboration/apply-poster-ops.library';
import {derivePosterOps} from '@PosterWhiteboard/collaboration/derive-poster-ops.library';

/**
 * The ops that undo `ops`, given the snapshot they were applied to. Publishing these is how one
 * person undoes their own change without rewinding anything a collaborator did in the meantime.
 */
export const invertPosterOps = (ops: PosterOp[], snapshotBefore: SnapshotRecord): PosterOp[] => {
  return derivePosterOps(applyPosterOps(snapshotBefore, ops), snapshotBefore);
};
